import React,{useContext} from "react";

import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const AdminLayout = ({ children }) => {
  const { sidebarOpen } = useContext(AdminRegistrationContext);

// Handle undefined case - default to true (sidebar open)
  const isSidebarOpen = sidebarOpen !== undefined ? sidebarOpen : true;
  
  // console.log("sidebarOpen", sidebarOpen);
  // console.log("isSidebarOpen (with fallback)", isSidebarOpen);
  return (
    <section id="admin-dashboard">
      <div className="admin-container">
        <AdminSidebar />
         <div className={`admin-display ${!isSidebarOpen ? 'sidebar-closed' : ''}`}>
          <AdminHeader />
          <div className="page-part">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default AdminLayout;
